/* Copyright (c) 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled, { css } from "styled-components";
import { theme, FlexContainer } from "@nordcloud/gnui";

export const DetailsItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DetailsDescription = styled.div`
  display: flex;
  align-items: center;
  word-break: normal;
  white-space: nowrap;
  width: 100%;
`;

export const ValueWrapper = styled.div<{ editable: boolean; isEmpty: boolean }>`
  position: relative;
  display: flex;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ editable }) => editable && EditableUnderline}

  color: ${({ isEmpty }) =>
    isEmpty ? theme.color.text.text02 : theme.color.text.text01};
`;

const EditableUnderline = css<{ isEmpty: boolean }>`
  text-decoration: underline;
  text-decoration-style: dotted;
  text-decoration-thickness: 1px;
  text-decoration-color: ${({ isEmpty }) =>
    isEmpty ? theme.color.text.text02 : theme.color.text.text01};
  text-underline-offset: ${theme.spacing.spacing01};
`;

export const DetailWrapper = styled(FlexContainer)`
  width: fit-content;

  :hover > Button {
    visibility: visible;
  }

  &:hover ${ValueWrapper} {
    text-decoration: none;
  }
`;
